import { MapPinIcon } from "@heroicons/react/24/outline";
import React from "react";

interface ViewMapButtonProps {
    onClick: () => void;
}

export const ViewMapButton: React.FC<ViewMapButtonProps> = ({ onClick }) => {
    return (
        <div className="fixed bottom-0 left-0 right-0 z-10 block lg:hidden bg-white border-t border-gray-200 p-2 shadow-lg">
            <button
                onClick={onClick}
                className="w-full text-center flex items-center justify-center space-x-2 px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-brand-600 hover:bg-brand-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-brand-500">
                <MapPinIcon className="h-6 w-6" />
                <span className="block">View Map</span>
            </button>
        </div>
    );
};
